export default "__VITE_ASSET__DW7iZD60__"